import { Directive, HostListener, Input } from '@angular/core';
import { FormTableDataSourceDirective } from './form-table-data-source.directive';
import { coerceBoolean, Required } from '@rxap/utilities';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[rxapFormTableDeleteRow]',
  standalone: true,
})
export class FormTableDeleteRowDirective<Data extends Record<string, any>> {

  @Input({required: true, alias: 'rxapFormTableDeleteRow'})
  public row!: Data;

  constructor(private readonly formTableDataSourceDirective: FormTableDataSourceDirective<Data>) {
  }

  private _hasConfirmDirective = false;

  // eslint-disable-next-line @angular-eslint/no-input-rename
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('rxapConfirm')
  public set hasConfirmDirective(value: any) {
    this._hasConfirmDirective = coerceBoolean(value);
  }

  @HostListener('click')
  public onClick() {
    if (!this._hasConfirmDirective) {
      this.execute();
    }
  }

  @HostListener('confirmed')
  public onConfirm() {
    this.execute();
  }

  protected execute() {
    const value = this.formTableDataSourceDirective.control.value;
    const index = value.findIndex(item => item === this.row);
    this.formTableDataSourceDirective.control.removeAt(index);
  }

}


